import { Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useExpensePresenter } from './useExpensePresenter'
import { ExpenseSummary } from '../../views/ExpenseSummary'
import { ExpenseSummaryLoader } from '../../views/ExpenseSummaryLoader'

export interface IExpensePresenterProps {
  uuid: string
  showCostSummary?: boolean
  showHeader?: boolean
}

export const ExpensePresenter = ({
  uuid,
  showCostSummary = true,
  showHeader = true,
}: IExpensePresenterProps) => {
  const intl = useProcurifyIntl()
  const { expense, isLoading, error } = useExpensePresenter({
    uuid,
  })

  if (isLoading) {
    return <ExpenseSummaryLoader />
  }

  if (error || !expense) {
    return <Text>{intl.formatMessage(messages.errorMessage)}</Text>
  }

  return (
    <ExpenseSummary
      expense={expense}
      showCostSummary={showCostSummary}
      showHeader={showHeader}
    />
  )
}

ExpensePresenter.displayName = 'ExpensePresenter'
